import React from "react";
import "../../../styles/main.css";
import PageHeader from "../../../components/reusable/ModuleHeader/PageHeader";
import Breadcrumb from "../../../components/reusable/ModuleHeader/Breadcrumb";



const Page41 = () => {
  return (

    <div style={{ padding: 4 }}>
      <Breadcrumb
        items={[
          { label: "Accueil", href: "/HomePage" },
          { label: "Tableau de bord", href: "/dashboard" },
        ]}
      />
      <PageHeader
        title="Overview"
        subtitle="Suivez la progression des activités et les performances clés du projet"
        className= "title-pulse"
      />
      {/* Contenu de la page */}
      
      
    </div>

  );
};

export default Page41;
